import { Pipe, PipeTransform } from '@angular/core';
import { ShortAddress } from '@common/index';

@Pipe({
    name: 'addressShorter'
})
export class AddressShorterPipe implements PipeTransform
{
    transform(value: string, ...args: unknown[]): unknown
    {
        return ShortAddress(value, ...args);
    }
}
